import { useEffect } from 'react';
import { initializeChurnKey } from '../../utils';

interface UseChurnKeyIntegrationWithConfigProps {
  enable?: boolean;
  appId?: string;
  onError?: (error: any) => void;
}

const useChurnKeyIntegrationWithConfig = ({
  enable = true,
  onError,
}: UseChurnKeyIntegrationWithConfigProps = {}) => {
  const appId = process.env.REACT_APP_CHURNKEY_APP_ID;

  useEffect(() => {
    if (!enable) return;

    try {
      if (appId) {
        initializeChurnKey(appId);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing ChurnKey:', error);
      }
      onError?.(error);
    }
  }, [enable, appId, onError]);

  return null;
};

export default useChurnKeyIntegrationWithConfig;
